import { useContext, useMemo, useState } from "react";
import { Position } from "reactflow";
import EmailImage from "../../assets/images/emailIcon.svg";
import NodeContext from "../../context/NodeContext";
import {
  ActionButtonContainer,
  EmailNode as StyledEmailNode,
} from "./EmailNode.styled";
import DeleteIconImg from "../../assets/images/deleteIcon.svg";
import AddNodeSelector from "../../components/AddNodeSelector";
import { BottomEdge, TopEdge } from "../StartingNode/StartingNode.styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "@mui/material";
import { Button } from "../../components/ui/button";
// import { getDraftToHTML } from "../../utils/helper";
// import { EMPTY_DRAFT } from "../../utils/constants";

function EmailNode(props) {
  const { id, data } = props;
  const {
    titleText,
    messageType,
    isTop,
    isBottom,
    smsMessage,
    emailSubject,
    isVariableMissing,
    isMessageEmpty,
    active
  } = data;
  const { handleNodeClick, edges, deleteNode, selectedNodeInfo, isEditable } =
    useContext(NodeContext);
  const [showAddBox, setShowAddBox] = useState(false);
  const [visible, setVisible] = useState(false);

  const isBottomEdgeConnected = useMemo(
    () =>
      edges.findIndex(
        (edge) => edge.source === id && edge.sourceHandle === "bottom"
      ) !== -1,
    [edges, id]
  );

  // const text = message;
  // const draftToHTML = useMemo(() => {
  //   return getDraftToHTML(text);
  // }, [text]);

  return (
    <>
      {isTop ? (
        <TopEdge
          type="target"
          position={Position.Top}
          id="top"
          isConnectable={true}
          iseditable={isEditable ? "true" : undefined}
        />
      ) : null}

      <StyledEmailNode
        $isActive={active ? active : selectedNodeInfo?.id === id}
        onClick={() => handleNodeClick(id)}
      >
        <div className="titleContainer">
          <img src={EmailImage} alt="emailIcon" width={18} />
          <span className="titleText">{titleText}</span>
        </div>
        {messageType === "email" ? (
          <div className="messageContainer">
            <span
              className="message"
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "100%",
                display: "inline-block",
                fontSize: "14px",
                fontWeight: "700",
              }}
            >
              {emailSubject.length > 0
                ? emailSubject.length > 40
                  ? `${emailSubject.slice(0, 40 - emailSubject.length)}...`
                  : emailSubject
                : "Subject for the email..."}
            </span>
          </div>
        ) : (
          <div className="messageContainer">
            <span
              className="message"
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "100%",
                display: "inline-block",
                fontSize: "14px",
                fontWeight: "700",
              }}
            >
              {smsMessage.length > 0
                ? smsMessage.length > 40
                  ? `${smsMessage.slice(0, 40 - smsMessage.length)}...`
                  : smsMessage
                : "Enter SMS Text..."}
            </span>
          </div>
        )}
        {isEditable && (
          <ActionButtonContainer
            className="action-btns"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={DeleteIconImg}
              alt="deleteIcon"
              onClick={() => {
                //   deleteNode(id);
                setVisible(true);
              }}
            />
          </ActionButtonContainer>
        )}
        {(isVariableMissing || isMessageEmpty) && (
          <div
            style={{
              position: "absolute",
              top: "15px",
              right: "15px",
            }}
          >
            <Tooltip
              title={
                isMessageEmpty
                  ? "Message is empty"
                  : "This node contains non-existing variable"
              }
            >
              <span
                style={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                }}
              >
                <FontAwesomeIcon
                  icon={faCircleExclamation}
                  style={{ color: "#fdd626" }}
                />
              </span>
            </Tooltip>
          </div>
        )}
        {visible && isEditable && (
          <ActionButtonContainer
            className="action-btns"
            onClick={(e) => e.stopPropagation()}
            style={{
              right: "-315px",
              top: "-35px",
              height: "auto",
              width: "250px",
              padding: "10px",
            }}
          >
            <span
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                fontFamily: "Plus Jakarta Sans, sans-serif",
                marginBottom: "10px",
                color: "#000",
              }}
            >
              Are you sure you want to delete?
            </span>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "150px",
                margin: "auto",
                padding: "10px 8px",
                gap: "20px",
              }}
            >
              <Button
                variant="outline"
                className="rounded-[5px] px-[10px] py-[5px] h-auto border-[#007372] text-[#007372] hover:bg-teal-50 hover:text-[#007372] hover:border-[#007372]"
                onClick={(e) => {
                  e.stopPropagation();
                  setVisible(false);
                }}
              >
                Cancel
              </Button>
              <Button
                variant="outline"
                className="rounded-[5px] px-[10px] py-[5px] h-auto border-[#ef4949] text-[#ef4949] hover:bg-red-50 hover:text-[#ef4949] hover:border-[#ef4949]"
                onClick={() => {
                  setVisible(false);
                  deleteNode(id);
                }}
              >
                Delete
              </Button>
            </div>
          </ActionButtonContainer>
        )}
        {showAddBox ? (
          <AddNodeSelector nodeData={props} setShowAddBox={setShowAddBox} />
        ) : null}
      </StyledEmailNode>

      {isBottom ? (
        <BottomEdge
          type="source"
          position={Position.Bottom}
          id="bottom"
          isConnectable={!isBottomEdgeConnected}
          onClick={() => {
            handleNodeClick(id);
            setShowAddBox(!showAddBox);
          }}
          iseditable={isEditable ? "true" : undefined}
        />
      ) : null}
    </>
  );
}

export default EmailNode;
